import { Card, CardFooter } from "@/components/ui/card";
import { LoadingIndicator } from "@/components/ui/loading-indicator";
import useMusioApi from "@/contexts/client/musio-client-context";

const BillingInfoCard = () => {
  const { musioApi } = useMusioApi();

  const { data: paddle_customer, isPending: isPaddleCustomerPending } = musioApi.useQuery("get", "/user/paddle-billing");

  const { mutate, isPending } = musioApi.useMutation('post', "/user/paddle-billing", {
    onSuccess: (data) => {
      window.open(data.portalUrl, "__blank");
    },
  });

  if (isPaddleCustomerPending || paddle_customer?.customer_id == undefined) {
    return null;
  }

  return (
    <Card className="bg-musio-bg flex flex-col justify-center items-center py-2">
      {/*<CardHeader className="p-2">
        <CardTitle className="text-lg">
          Payment Method
        </CardTitle>
      </CardHeader>*/}
      {/*<CardContent className="text-sm text-musio-gray">
        VISA **** **** **** 1234
      </CardContent>*/}
      <CardFooter className="text-sm text-musio-green underline py-2 cursor-pointer">
        {isPending ?
          <LoadingIndicator /> :
          <a
            onClick={() => mutate({})}
          >
            Manage Billing Information
          </a>
        }
      </CardFooter>
    </Card>
  );
};

export default BillingInfoCard;
